export const general_sv = {
  'find_walks' : 'Hitta',
  'create_walk' : 'Skapa',
  'my_page' : 'Min sida',
  'chat_page' : 'Chatt',
  'public': 'Offentliga',
  'filters': 'Fler filter',
  'all' : 'Alla',
  '7_days': '7 dagar',
  '30_days': '30 dagar',
  'today': 'Idag',
  'yesterday' : 'Igår',
  'month': 'Månad',
  'week' : 'Vecka',
  'day' : 'Dag',
  'close' : 'Stäng',
  'choose' : 'Välj',
  'save' : 'Spara',
  'cancel' : 'Avbryt',
  'send' : 'Skicka',
  'done' : 'Klar',
  'error_message' : 'Felmeddelande',
  'message' : 'Meddelande',
  'block' : 'Blockera ',
  'send_friendrequest' : 'Skicka vänförfrågan',
  'add_friend' : 'Lägg till vän',
  'log_out' : 'Logga ut',
  'log_in' : 'Logga in',
  'name' : 'Namn',
  'password' : 'Lösenord',
  'email' : 'Email',
  'biography' : 'Biografi',
  'language' : 'Språk',
  'change_picture' : 'Byt profilbild',
  'share_walk' : 'Dela promenaden',
  'add_to_calendar' : 'Lägg till i kalendern',
  'copy_walk' : 'Kopiera promenaden',
  'edit_walk' : 'Redigera promenaden',
  'remove_walk' : 'Ta bort promenaden',
  'save_walk' : 'Spara promenaden',
  'book_walk' : 'Boka promenad',
  'cancel_your_walk' : 'Ställ in promenad',
  'cancel_walk' : 'Avboka promenad',

  'booked_confirmation_header' : 'Promenaden är bokad',
  'walk_is_booked' : 'Promenaden är bokad',
  'chat_with' : 'Chatta med ',
  'send_link' : 'Skicka länken till någon du vill dela promenaden med',
  'copy_link' : 'Kopiera länk',
  'link_is_copied' : 'Länken är kopierad',

  'time_passed' : 'Tiden har passerat',
  'accept' : 'Acceptera',
  'deny' : 'Neka',
  'unblock' : 'Avblockera ',
  'unblock_message' : 'Tänk på att om du tar bort blockeringen kommer personen kunna interagera med dig i appen.',

  'could_not_load_profile' : 'Kunde inte ladda profilen, ladda om sidan eller kontakta Walking Talking om problemet kvarstår',
  'has_shared_profile' : ' har delat en profil med dig',
  'share_profile' : 'Dela din profil',
  'edit_your_profile' : 'Redigera din profil',
  'share_the_profile' : 'Dela profilen',
  's_profile' : 's profil',
  'send_link_profile_message' : 'Skicka länken nedan till den du vill dela profilen med.',
  'my_profile' : 'Min profil',
  'available_walks' : 'Tillgängliga promenader',

  'friendrequest_confirmation' : 'Vänförfrågan är skickad',

  'PRO_form_confirmation' : 'Tack så mycket, Walking Talking kommer höra av sig till dig inom kort.',

  'get_PRO' : 'Skaffa Walking Talking Pro för att låsa upp fler funktioner',
  'walking_talking_pro' : ' Walking Talking PRO ',
  'unlock_PRO' : 'för att låsa upp fler funktioner',
  'upgrade_contact' : 'Kontakta oss för att uppgradera',
  'available_functions' : 'Tillgängliga Pro funktioner',
  'pro_information' : 'Vill du få tillgång till fler funktioner och vara med och forma vår resa har du nu möjlighet att uppgradera ditt konto till Walking talking PRO.',
  'pro_promise' : 'Vi jobbar kontinuerligt med att utveckla appen och skapa fler funktioner. Uppgradera ditt konto för att bli först med att testa våra nya kommande funktioner',
  'platform_not_capacitor' : 'Ladda ner appen eller kontakta Walking Talking för att köpa Pro',
  'or': ' eller ',
  'bas' : 'Bas',
  'pro' : 'Pro',
  'business' : 'Business',
  'chat' : 'Chatta',
  'create_and_book' : 'Skapa och boka promenader',
  'send_private' : 'Skicka privata promenader',
  'copy_walks' : 'Kopiera promenader',
  'repeat_walks' : 'Skapa promenad planer',
  'group_walks' : 'Grupp promenader',
  'walking_talking_business' : 'Walking Talking Pro + Business',
  'walking_talking_business_information' : 'Vill du och ditt företag eller organisation får tillgång till privata utrymmen och team-funktionalitet i appen?',
  'pro_plus_business' : 'Walking Talking PRO + Business',
  'own_app_space' : 'Eget nätverk i appen',
  'business_support' : 'Företags support',
  'pick_network_type' : 'Välj nätverkstyp',
  'business_type' : 'Företag',

  'upload_picture' : 'Ladda upp bild',
  'choose_picture' : 'Välj ny bild',
  'smaller' : 'Mindre',
  'bigger' : 'Större',
  'rotate_left' : 'Rotera vänster',
  'rotate_right' : 'Rotera höger',

  'get_PRO_message_alert' : 'För att skapa privata promenader måste du uppgradera till Walking Talking PRO',

  'log_in_for_profile' : 'Logga in för att ta del av hela profilen.',
  
  'visibility' : 'Synlighet',
  'only_my_profile' : 'Endast min profil',
  'number_of_participants' : 'Antal deltagare',
  'walk_type' : 'Promenadtyp',
  'meet_location' : 'Möts på plats',
  'audio_walk' : 'Audiopromenad',
  'audio_location' : 'Audio eller mötas',
  'whoWhen' : 'Du:',
  'message_to' : 'Meddelande till ',

  'audiowalk_info' : 'I en audiopromenad kan alla som bokar gå in i ett privat samtalsrum i appen. Vare sig du vill träffa en helt främmande person, en vän eller ta ett jobbmöte gåendes så gör audiopromenaden det lättare för människor att mötas på sina villkor.',

  'list_my_walks' : 'Lista',
  'not_booked_walk_card' : 'Promenaden är inte bokad - Dela den',
  'clicking_share_button' : 'Skicka länken nedan till någon du vill dela denna promenad med',

  'find_page_network' : 'Mina nätverk',
  'list_view_walks' : 'I morgon',
  'second_view_walks' : 'I dag',
  'inside_networks_top' : 'Välj nätverk',
  'networks_left_select' : 'Mina',
  'right_networks_select' : 'Offentliga',
  'second_my_networks' : 'Mina nätverk',
  'public_toggle_network' : 'Offentliga',
  'bottom_filter_button' : 'Filtrera',


  'top_left_text' : 'Nätverk',
  'network_members' : 'Medlemmar',
  'inside_share' : 'Dela nätverk',
  'share_name_specific' : 'Dela',
  'qr_code_explanation' : 'Scanna koden för att bli medlem i nätverket eller dela länken för att bjuda in någon.',
  'bottom_copy_link' : 'Kopiera länken',
  'when_copy_button_pressed' : 'Länken är kopierad',
  'looking_public_network' : 'Gå med i nätverket',

  'oops_couldnotfind_team' : 'Oops - hittade inte teaminbjudan',
  'somethingwrong_team' : 'Något gick snett, kontakta ansvarig ägare till nätverket eller support: kontakt@walkingtalking.com',
  'does_notexist' : 'Finns inte',
  'inactive_team' : 'Det här nätverket är inte längre aktivt.',
  'active_member' : 'Aktiv medlem',
  'already_member' : 'Du är redan medlem i ',
  'cantsee_team' : ', ser du inte teamet testa logga ut och in. Om problemet kvarstår kontakta support på kontakt@walkingtalking.com.',
  'welcome_team' : 'Welcome to ',
  'start_walking' : 'Nu kan du börja promenera med andra medlemmar i nätverket',
  'view_network' : 'Se dina nätverk',
  'go_homepage' :'Gå till startsidan',
  'my_walks' : 'Mina promenader',
  
  'my_walk_filter' : 'Mina promenader filter',

  'added_to_cal' : 'La till i din kalender',
  'wrong_error' : 'Felmeddelande: ',
  'deleted_event' : 'Borttaget event',
  'created_eventt' : 'Skapat event',

  'available_calendars' : 'Nedan ser du en lista på de kalendrar appen har tillgång till. Välj vilken du vill lägga till i.',
  'no_calendars' : 'Kunde inte hitta någon kalender',

  'type_association' : 'Förening',
'type_other' : 'Annat',
'confirm_contact' : 'Jag godkänner att Walking Talking får kontakta mig med erbjudanden, nyheter och uppdateringar.',
'by_clicking_confirm' : "Genom att skicka in godkänner du Walking Talkings",

}